import api from '@/api'

const setting = {
  getLottery() {
    return api.get(`/setting/lottery`)
  },
}

export default setting
